import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createFormFieldAsync, updateFormFieldAsync, deleteFormFieldAsync, getFormFieldByIdAsync, getFormFieldsByFormStepIdAsync, getIdentityFormFieldsByEventIdAsync } from './formFieldThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const formFieldSlice = createSlice({
    name: 'formField',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createFormFieldAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createFormFieldAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formFields = action.payload;
        })
            .addCase(createFormFieldAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateFormFieldAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateFormFieldAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formField = action.payload;
        })
            .addCase(updateFormFieldAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteFormFieldAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteFormFieldAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
            // Note: For delete operations, we don't need to update state with returned data
            // The UI will refresh the form field list separately
        })
            .addCase(deleteFormFieldAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFormFieldByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFormFieldByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formField = action.payload;
        })
            .addCase(getFormFieldByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFormFieldsByFormStepIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFormFieldsByFormStepIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formFields = action.payload;
        })
            .addCase(getFormFieldsByFormStepIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getIdentityFormFieldsByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getIdentityFormFieldsByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.identityFormFields = action.payload;
        })
            .addCase(getIdentityFormFieldsByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default formFieldSlice.reducer;
